import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import "../CSS/Gallery.css";
import NavBar from "../components/NavBar";
import Header from "../components/header";
import Footer from "../components/Footer";
import WhatsAppContact from "../components/WhatsAppContact";

const GalleryBanner =
  "https://res.cloudinary.com/dzgzig4vx/image/upload/v1720195123/gallery_banner_afxfx2_a46xzk.webp";
const SearchIcon =
  "https://res.cloudinary.com/dzgzig4vx/image/upload/v1714810971/search_kn5zsw.png";
const Services1 =
  "https://res.cloudinary.com/dzgzig4vx/image/upload/v1720195123/gallery1_conmhe_nwdbbz.webp";
const Services2 =
  "https://res.cloudinary.com/dzgzig4vx/image/upload/v1720195123/gallery2_lgytm6_h2yi0t.webp";
const Services3 =
  "https://res.cloudinary.com/dzgzig4vx/image/upload/v1720195124/gallery3_ar8gig_qg8hyb.webp";
const Services4 =
  "https://res.cloudinary.com/dzgzig4vx/image/upload/v1720195127/gallery4_uq2wuj_ieyt6n.webp";
const Services5 =
  "https://res.cloudinary.com/dzgzig4vx/image/upload/v1720195127/gallery5_xnvldc_izsx15.webp";
const Services6 =
  "https://res.cloudinary.com/dzgzig4vx/image/upload/v1720195127/gallery6_hzigcv_ylm87j.webp";

const images = [
  {
    name: "service1",
    image: Services1,
  },
  {
    name: "service2",
    image: Services2,
  },
  {
    name: "service3",
    image: Services3,
  },
  {
    name: "service4",
    image: Services4,
  },
  {
    name: "service5",
    image: Services5,
  },
  {
    name: "service6",
    image: Services6,
  },
];

function MyGallery() {
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  }, []);

  return (
    <div className="main_gallery_container" style={{ backgroundColor: "#FFF" }}>
      <WhatsAppContact number="+966532022290" />
      <NavBar cname="Our Gallery"></NavBar>
      <Header
        heading="Discover Luxury in Every Detail"
        banner={GalleryBanner}
      ></Header>
      <Container className="main_gallery_body">
        <h1 className="heading">
          Explore Our <span>Gallery</span>
        </h1>
        <p className="description">
          Each image captures the essence of our commitment to excellence,
          highlighting the meticulous attention to detail and unparalleled
          comfort that defines our services. Explore our gallery and envision
          yourself experiencing the ultimate in luxury travel with us.
        </p>
        <div className="gallery_box_se">
          <div className="top">
            <Row>
              {images.length > 0 &&
                images.map((data, _idx) => (
                  <Col md="4">
                    <div className="card-box">
                      <a href={`#/ourgallery/#img_${_idx + 1}`}>
                        <img
                          className="image"
                          src={data.image}
                          alt={`Service ${_idx}`}
                        />
                        <div class="overlay">
                          <img className="icon" src={SearchIcon} alt="Icon" />
                        </div>
                      </a>
                    </div>
                  </Col>
                ))}
            </Row>
            {images.length &&
              images.map((data, _idx) => (
                <a
                  href={`#/ourgallery/img_${_idx + 1}`}
                  class="lightbox trans"
                  id={`#/ourgallery/img_${_idx + 1}`}
                >
                  <img src={data.image} alt={data.name} />
                </a>
              ))}
          </div>
        </div>
        <div className="load_btn">
          <button className="load_more">Load More</button>
        </div>
      </Container>
      <Footer />
    </div>
  );
}

export default MyGallery;
